// import { useState, useEffect } from 'react';
// import { Star, Users, Calendar, Award, Quote, ChevronLeft, ChevronRight, Smartphone, Monitor, Tablet } from 'lucide-react';

// const ClientTestimonials = () => {
//   const [currentTestimonial, setCurrentTestimonial] = useState(0);
//   const [isAutoPlaying, setIsAutoPlaying] = useState(true);

//   const stats = [
//     {
//       icon: Calendar,
//       value: "8+",
//       label: "Years of Excellence",
//       description: "Delivering cutting-edge solutions",
//       color: "#3B82F6"
//     },
//     {
//       icon: Users,
//       value: "500+",
//       label: "Happy Clients",
//       description: "Across global markets",
//       color: "#10B981"
//     },
//     {
//       icon: Award,
//       value: "1000+",
//       label: "Projects Completed",
//       description: "With 99% success rate",
//       color: "#F59E0B"
//     },
//     {
//       icon: Smartphone,
//       value: "100%",
//       label: "Mobile Responsive",
//       description: "All devices optimized",
//       color: "#8B5CF6"
//     }
//   ];

//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       position: "CEO, TechFlow Solutions",
//       company: "TechFlow Solutions",
//       rating: 5,
//       text: "Their innovative UI design transformed our business completely. The responsive design works flawlessly across all devices. Strategic thinking combined with creative execution - exactly what we needed!",
//       avatar: "SJ",
//       projectType: "E-commerce Platform",
//       results: "300% increase in user engagement"
//     },
//     {
//       name: "Michael Chen",
//       position: "CTO, InnovateLab",
//       company: "InnovateLab",
//       rating: 5,
//       text: "8 years of experience really shows in their work. The strategic approach to our mobile-first design was revolutionary. Every screen size looks perfect, and the user experience is phenomenal.",
//       avatar: "MC",
//       projectType: "Mobile Application",
//       results: "250% boost in mobile conversions"
//     },
//     {
//       name: "Emily Rodriguez",
//       position: "Founder, GreenTech Ventures",
//       company: "GreenTech Ventures",
//       rating: 5,
//       text: "Innovative doesn't even begin to describe their approach. The responsive design adapts beautifully to every device. Their strategic insight into user behavior helped us achieve incredible results.",
//       avatar: "ER",
//       projectType: "Web Application",
//       results: "400% improvement in user retention"
//     },
//     {
//       name: "David Park",
//       position: "Director, FinanceFirst",
//       company: "FinanceFirst",
//       rating: 5,
//       text: "The attention to detail in their UI design is remarkable. Every element is strategically placed for maximum impact. The responsive nature ensures our clients have a seamless experience everywhere.",
//       avatar: "DP",
//       projectType: "Dashboard System",
//       results: "180% increase in user satisfaction"
//     }
//   ];

//   const features = [
//     {
//       icon: Monitor,
//       title: "Innovative UI Design",
//       description: "Cutting-edge interfaces that captivate and convert",
//       gradient: "from-blue-500 to-purple-600"
//     },
//     {
//       icon: Smartphone,
//       title: "Mobile-First Approach",
//       description: "Responsive designs that work perfectly on all devices",
//       gradient: "from-green-500 to-teal-600"
//     },
//     {
//       icon: Award,
//       title: "Strategic Innovation",
//       description: "Data-driven solutions that deliver measurable results",
//       gradient: "from-orange-500 to-red-600"
//     }
//   ];

//   // Auto-play testimonials
//   useEffect(() => {
//     if (isAutoPlaying) {
//       const interval = setInterval(() => {
//         setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
//       }, 5000);
//       return () => clearInterval(interval);
//     }
//   }, [isAutoPlaying, testimonials.length]);

//   const nextTestimonial = () => {
//     setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   const prevTestimonial = () => {
//     setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   return (
//     <div className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-white/5 rounded-full transform rotate-45 animate-pulse"></div>
//         <div className="absolute -bottom-1/2 -left-1/2 w-full h-full bg-white/3 rounded-full transform -rotate-45 animate-pulse" style={{ animationDelay: '2s' }}></div>
//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto px-4 py-20">
//         {/* Header Section */}
//         <div className="text-center mb-16">
//           <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 animate-fadeIn">
//             Trusted by <span style={{ color: '#FDE047' }}>Industry Leaders</span>
//           </h2>
//           <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
//             8+ years of strategic innovation, delivering cutting-edge solutions that transform businesses across the globe
//           </p>
//         </div>

//         {/* Stats Section */}
//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
//           {stats.map((stat, index) => (
//             <div
//               key={index}
//               className="group relative bg-white/10 backdrop-blur-lg rounded-2xl p-6 text-center transform transition-all duration-500 hover:scale-105 hover:bg-white/20"
//               style={{ animationDelay: `${index * 0.2}s` }}
//             >
//               <div
//                 className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center transform transition-transform duration-500 group-hover:rotate-12"
//                 style={{ backgroundColor: stat.color }}
//               >
//                 <stat.icon className="w-8 h-8 text-white" />
//               </div>
//               <div className="text-3xl md:text-4xl font-bold text-white mb-2">
//                 {stat.value}
//               </div>
//               <div className="text-lg font-semibold text-white/90 mb-2">
//                 {stat.label}
//               </div>
//               <div className="text-sm text-white/70">
//                 {stat.description}
//               </div>
              
//               {/* Hover Effect Border */}
//               <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-white/30 transition-all duration-500"></div>
//             </div>
//           ))}
//         </div>

     
//         {/* Testimonials Carousel */}
//         <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 md:p-12">
//           <div className="text-center mb-12">
//             <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
//               What Our Clients Say
//             </h3>
//             <p className="text-white/80 text-lg">
//               Real stories from real clients who experienced our innovative solutions
//             </p>
//           </div>

//           <div className="relative max-w-4xl mx-auto">
//             {/* Main Testimonial */}
//             <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl transform transition-all duration-700">
//               <div className="flex flex-col md:flex-row items-start gap-8">
//                 {/* Avatar */}
//                 <div className="flex-shrink-0">
//                   <div
//                     className="w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold text-white"
//                     style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)' }}
//                   >
//                     {testimonials[currentTestimonial].avatar}
//                   </div>
//                 </div>

//                 {/* Content */}
//                 <div className="flex-1">
//                   {/* Quote Icon */}
//                   <Quote className="w-8 h-8 mb-6" style={{ color: '#667eea' }} />
                  
//                   {/* Stars */}
//                   <div className="flex gap-1 mb-4">
//                     {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
//                       <Star key={i} className="w-5 h-5 fill-current" style={{ color: '#FDE047' }} />
//                     ))}
//                   </div>

//                   {/* Testimonial Text */}
//                   <p className="text-lg leading-relaxed mb-6" style={{ color: '#374151' }}>
//                     "{testimonials[currentTestimonial].text}"
//                   </p>

//                   {/* Client Info */}
//                   <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
//                     <div>
//                       <h4 className="font-bold text-xl" style={{ color: '#1F2937' }}>
//                         {testimonials[currentTestimonial].name}
//                       </h4>
//                       <p style={{ color: '#6B7280' }}>
//                         {testimonials[currentTestimonial].position}
//                       </p>
//                       <p className="text-sm font-medium" style={{ color: '#667eea' }}>
//                         {testimonials[currentTestimonial].company}
//                       </p>
//                     </div>
                    
//                     <div className="text-right">
//                       <div className="text-sm font-medium mb-1" style={{ color: '#6B7280' }}>
//                         Project: {testimonials[currentTestimonial].projectType}
//                       </div>
//                       <div className="text-sm font-bold" style={{ color: '#10B981' }}>
//                         {testimonials[currentTestimonial].results}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Navigation Buttons */}
//             <button
//               onClick={prevTestimonial}
//               className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-lg rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 hover:scale-110"
//             >
//               <ChevronLeft className="w-6 h-6" />
//             </button>
            
//             <button
//               onClick={nextTestimonial}
//               className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-lg rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 hover:scale-110"
//             >
//               <ChevronRight className="w-6 h-6" />
//             </button>

//             {/* Dots Indicator */}
//             <div className="flex justify-center gap-3 mt-8">
//               {testimonials.map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => {
//                     setCurrentTestimonial(index);
//                     setIsAutoPlaying(false);
//                   }}
//                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                     index === currentTestimonial
//                       ? 'bg-white scale-125'
//                       : 'bg-white/40 hover:bg-white/60'
//                   }`}
//                 />
//               ))}
//             </div>
//           </div>
//               </div>
              
//         {/* Call to Action */}
//         <div className="text-center mt-16">
//           <h3 className="text-3xl font-bold text-white mb-6">
//             Ready to Join Our Success Stories?
//           </h3>
//           <button className="group bg-white text-purple-600 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl">
//             Start Your Project Today
//             <span className="inline-block ml-2 transform transition-transform duration-300 group-hover:translate-x-1">→</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ClientTestimonials;




import { useState, useEffect } from 'react';
import { Star, Users, Calendar, Award, Quote, ChevronLeft, ChevronRight, Smartphone, Monitor, Tablet, ArrowRight } from 'lucide-react';

const ClientTestimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const stats = [
    {
      icon: Calendar,
      value: "8+",
      label: "Years of Excellence",
      description: "Delivering cutting-edge solutions",
      color: "#3B82F6"
    },
    {
      icon: Users,
      value: "500+",
      label: "Happy Clients",
      description: "Across global markets",
      color: "#10B981"
    },
    {
      icon: Award,
      value: "1000+",
      label: "Projects Completed",
      description: "With 99% success rate",
      color: "#F59E0B"
    },
    {
      icon: Smartphone,
      value: "100%",
      label: "Mobile Responsive",
      description: "All devices optimized",
      color: "#8B5CF6"
    }
  ];

  const testimonials = [
    {
      name: "Sarah Johnson",
      position: "CEO, TechFlow Solutions",
      company: "TechFlow Solutions",
      rating: 5,
      text: "Their innovative UI design transformed our business completely. The responsive design works flawlessly across all devices. Strategic thinking combined with creative execution - exactly what we needed!",
      avatar: "SJ",
      projectType: "E-commerce Platform",
      results: "300% increase in user engagement"
    },
    {
      name: "Michael Chen",
      position: "CTO, InnovateLab",
      company: "InnovateLab",
      rating: 5,
      text: "8 years of experience really shows in their work. The strategic approach to our mobile-first design was revolutionary. Every screen size looks perfect, and the user experience is phenomenal.",
      avatar: "MC",
      projectType: "Mobile Application",
      results: "250% boost in mobile conversions"
    },
    {
      name: "Emily Rodriguez",
      position: "Founder, GreenTech Ventures",
      company: "GreenTech Ventures",
      rating: 5,
      text: "Innovative doesn't even begin to describe their approach. The responsive design adapts beautifully to every device. Their strategic insight into user behavior helped us achieve incredible results.",
      avatar: "ER",
      projectType: "Web Application",
      results: "400% improvement in user retention"
    },
    {
      name: "David Park",
      position: "Director, FinanceFirst",
      company: "FinanceFirst",
      rating: 5,
      text: "The attention to detail in their UI design is remarkable. Every element is strategically placed for maximum impact. The responsive nature ensures our clients have a seamless experience everywhere.",
      avatar: "DP",
      projectType: "Dashboard System",
      results: "180% increase in user satisfaction"
    }
  ];

  // Auto-play testimonials
  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isAutoPlaying, testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
  };

  return (
    <div className="relative overflow-hidden min-h-screen" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          {/* Animated Background Elements */}
          
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-white/5 rounded-full transform rotate-45 animate-pulse"></div>
        <div className="absolute -bottom-1/2 -left-1/2 w-full h-full bg-white/3 rounded-full transform -rotate-45 animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-gradient-to-r from-purple-400/20 to-pink-400/20 rounded-full blur-xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 right-1/4 w-24 h-24 bg-gradient-to-r from-blue-400/20 to-cyan-400/20 rounded-full blur-xl animate-pulse" style={{ animationDelay: '3s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 py-6 sm:py-8 lg:py-12">
        {/* Header Section - Reduced spacing */}
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-3 sm:mb-4" style={{ color: '#FFFFFF' }}>
            Trusted by <span style={{ color: '#FDE047' }}>Industry Leaders</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl max-w-3xl mx-auto leading-relaxed" style={{ color: '#F3F4F6' }}>
            8+ years of strategic innovation, delivering cutting-edge solutions that transform businesses across the globe
          </p>
        </div>

        {/* Stats Section - Improved responsive grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 mb-12 sm:mb-16">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="group relative bg-white/10 backdrop-blur-lg rounded-xl sm:rounded-2xl p-3 sm:p-4 lg:p-6 text-center transform transition-all duration-500 hover:scale-105 hover:bg-white/20 border border-white/10 hover:border-white/30"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div 
                className="w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 mx-auto mb-2 sm:mb-3 lg:mb-4 rounded-full flex items-center justify-center transform transition-transform duration-500 group-hover:rotate-12"
                style={{ backgroundColor: stat.color }}
              >
                <stat.icon className="w-4 h-4 sm:w-5 sm:h-5 lg:w-8 lg:h-8 text-white" />
              </div>
              <div className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold mb-1 sm:mb-2" style={{ color: '#FFFFFF' }}>
                {stat.value}
              </div>
              <div className="text-xs sm:text-sm lg:text-lg font-semibold mb-1 sm:mb-2" style={{ color: '#F3F4F6' }}>
                {stat.label}
              </div>
              <div className="text-xs sm:text-sm" style={{ color: '#D1D5DB' }}>
                {stat.description}
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials Carousel - Enhanced design */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 xl:p-12 border border-white/20">
          <div className="text-center mb-6 sm:mb-8 lg:mb-12">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-2 sm:mb-4" style={{ color: '#FFFFFF' }}>
              What Our Clients Say
            </h3>
            <p className="text-sm sm:text-base lg:text-lg text-center" style={{ color: '#D1D5DB' }}>
              Write any para here about the testimonials, highlighting the positive impact and satisfaction of our clients.
            </p>
          </div>

          <div className="relative max-w-5xl mx-auto">
            {/* Main Testimonial */}
            <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 xl:p-12 shadow-2xl transform transition-all duration-700 border border-gray-100">
              <div className="flex flex-col lg:flex-row items-start gap-4 sm:gap-6 lg:gap-8">
                {/* Avatar */}
                <div className="flex-shrink-0 mx-auto lg:mx-0">
                  <div 
                    className="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center text-lg sm:text-xl lg:text-2xl font-bold text-white shadow-lg"
                    style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)' }}
                  >
                    {testimonials[currentTestimonial].avatar}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 text-center lg:text-left">
                  {/* Quote Icon */}
                  <Quote className="w-6 h-6 sm:w-8 sm:h-8 mb-3 sm:mb-4 lg:mb-6 mx-auto lg:mx-0" style={{ color: '#667eea' }} />
                  
                  {/* Stars */}
                  <div className="flex gap-1 mb-3 sm:mb-4 justify-center lg:justify-start">
                    {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-current" style={{ color: '#FDE047' }} />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-sm sm:text-base lg:text-lg leading-relaxed mb-4 sm:mb-6" style={{ color: '#374151' }}>
                    "{testimonials[currentTestimonial].text}"
                  </p>

                  {/* Client Info */}
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
                    <div>
                      <h4 className="font-bold text-lg sm:text-xl" style={{ color: '#1F2937' }}>
                        {testimonials[currentTestimonial].name}
                      </h4>
                      <p className="text-sm sm:text-base" style={{ color: '#6B7280' }}>
                        {testimonials[currentTestimonial].position}
                      </p>
                      <p className="text-xs sm:text-sm font-medium" style={{ color: '#667eea' }}>
                        {testimonials[currentTestimonial].company}
                      </p>
                    </div>
                    
                    <div className="text-center sm:text-right">
                      <div className="text-xs sm:text-sm font-medium mb-1" style={{ color: '#6B7280' }}>
                        Project: {testimonials[currentTestimonial].projectType}
                      </div>
                      <div className="text-xs sm:text-sm font-bold px-2 py-1 rounded-full bg-green-50" style={{ color: '#10B981' }}>
                        {testimonials[currentTestimonial].results}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Buttons - Hidden on small screens */}
            <button 
              onClick={prevTestimonial}
              className="hidden sm:flex absolute left-2 lg:left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 lg:w-12 lg:h-12 bg-white/20 backdrop-blur-lg rounded-full items-center justify-center text-white hover:bg-white/30 transition-all duration-300 hover:scale-110 border border-white/20"
            >
              <ChevronLeft className="w-5 h-5 lg:w-6 lg:h-6" />
            </button>
            
            <button 
              onClick={nextTestimonial}
              className="hidden sm:flex absolute right-2 lg:right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 lg:w-12 lg:h-12 bg-white/20 backdrop-blur-lg rounded-full items-center justify-center text-white hover:bg-white/30 transition-all duration-300 hover:scale-110 border border-white/20"
            >
              <ChevronRight className="w-5 h-5 lg:w-6 lg:h-6" />
            </button>

            {/* Mobile Navigation Buttons */}
            <div className="flex sm:hidden justify-center gap-4 mt-6">
              <button 
                onClick={prevTestimonial}
                className="w-12 h-12 bg-white/20 backdrop-blur-lg rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 border border-white/20"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              
              <button 
                onClick={nextTestimonial}
                className="w-12 h-12 bg-white/20 backdrop-blur-lg rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 border border-white/20"
              >
                <ChevronRight className="w-6 h-6" />
              </button>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 sm:gap-3 mt-6 sm:mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setCurrentTestimonial(index);
                    setIsAutoPlaying(false);
                  }}
                  className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                    index === currentTestimonial 
                      ? 'bg-white scale-125' 
                      : 'bg-white/40 hover:bg-white/60'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
              
        {/* Call to Action - Improved responsive design */}
        <div className="text-center mt-12 sm:mt-16">
          <h3 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6" style={{ color: '#FFFFFF' }}>
            Ready to Join Our Success Stories?
          </h3>
          <button className="group bg-white rounded-full font-bold transition-all duration-300 hover:scale-105 hover:shadow-2xl px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg border-2 border-transparent hover:border-white/20" style={{ color: '#8B5CF6' }}>
            Start Your Project Today
            <ArrowRight className="inline-block ml-2 w-4 h-4 sm:w-5 sm:h-5 transform transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientTestimonials;